module.exports = __webpack_public_path__ + "6e4532f18c365bcad3b93700ef892cf2.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/pricing_couples.svg
// module id = 1295
// module chunks = 74